import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Resume from "./pages/Resume";
import ResilienceModels from "./pages/ResilienceModels";
import ProfessionalTraining from "./pages/ProfessionalTraining";
import SchoolProjects from "./pages/SchoolProjects";
import MonthlyPages from "./pages/MonthlyPages";
import NarrativeWriting from "./pages/NarrativeWriting";
import Awards from "./pages/Awards";
import Inspiration from "./pages/Inspiration";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <HashRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/resilience-models" element={<ResilienceModels />} />
          <Route path="/professional-training" element={<ProfessionalTraining />} />
          <Route path="/school-projects" element={<SchoolProjects />} />
          <Route path="/monthly-pages" element={<MonthlyPages />} />
          <Route path="/narrative-writing" element={<NarrativeWriting />} />
          <Route path="/awards" element={<Awards />} />
          <Route path="/inspiration" element={<Inspiration />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/resume" element={<Resume />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
